import { ready } from '~/core';
import { addEvents } from '~/utils';

import { pickit, upload, validate } from '~/utils';

//add date picker functionality
ready('datePicker', 'input[data-date-picker]', input => {
  let mq = window.matchMedia("(max-width: 600px)");


  const readOnlyField = () => {
    if (mq.matches) {
      input.setAttribute('readonly', 'readonly')
    }
    else {
      input.removeAttribute('readonly')
    }
  }
  mq.addListener(readOnlyField);
  readOnlyField()
  pickit(input);
});

ready('htmlDatePicker', '.form--stylePrimary', allForm => {
  const formFields = [...allForm.querySelectorAll('input[type=date]')];
  const prepare = field => {
    field.addEventListener('blur', (e) => {
      field.blur();
    });
  }
  const config = { attributes: false, childList: true, subtree: true };
  const targetNode = document.querySelector('.form--stylePrimary');

  //created mutation observer for kentico conditional fields changing dom
  const callback = function (mutationsList, observer) {
    let formFieldsUpdate = [...allForm.querySelectorAll('input[type=date]')];
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        formFieldsUpdate.forEach(formField => prepare(formField));
      }
    }
  }
  const observer = new MutationObserver(callback);
  formFields.forEach(formField => prepare(formField));
  observer.observe(allForm, config);

});


//add file upload functionality
ready('fileUpload', '.fileUpload input', input => {
  upload(input);
});

//add validation functionality
ready('required_kentico_fields', 'form > .ktc-default-section', form => {
  const requireds = form.querySelectorAll('input[required], select[required], textarea[required]');

  requireds.forEach(req => {
    let parent =
      req.getAttribute('type') === 'radio' ? req.parentElement.parentElement : req.parentElement;
    let label = undefined;
    let i = 0;

    while (label === undefined && i++ < 5) {
      label = parent.querySelector(':scope > label') || undefined;
      if (!label) {
        parent = parent.parentElement;
      }
    }
    if (label) {
      label.classList.add('is-required');
    }
  });
});

//add validation functionality
ready('validation', '.formValidate', form => {
  validate(form);
});

ready(
  'phone_keyboard',
  'input[type=tel], input[id*=phone], input[id*=Phone], input[name*=phone], input[name*=Phone]',
  input => {
    // Numeric keypad hint only. A native pattern="[0-9]*" here rejected formatted numbers like
    // "(222) 333-3333" ("Please match the requested format"); format rules belong to the form field's
    // own validation, not a blanket digits-only pattern.
    input.setAttribute('inputmode', 'tel');
  }
);

// ready('email_masking', 'input[type=email], input[inputmode=email]', input => {
// 	input.setAttribute('placeholder', '_@_.__');
// 	input.setAttribute('inputmode', 'email');
// 	input.setAttribute('type', 'text');
// 	const im = Inputmask({
// 		supportsInputType: 'email',
// 		mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}.*{2,6}[.*{1,2}]',
// 		greedy: false,
// 		onBeforePaste: function(pastedValue, opts) {
// 			pastedValue = pastedValue.toLowerCase();
// 			return pastedValue.replace('mailto:', '');
// 		},
// 		definitions: {
// 			'*': {
// 				validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]",
// 				casing: 'lower',
// 			},
// 		},
// 	});
// 	im.mask(input);
// });



//kentico form fields
ready('formTips', '.form--stylePrimary', form => {
  const formFields = [...form.querySelectorAll('.form-field')];
  const config = { attributes: false, childList: true, subtree: true };
  const targetNode = document.querySelector('.form--stylePrimary');

  //created mutation observer for kentico conditional fields changing dom
  const callback = function (mutationsList, observer) {
    let formFieldsUpdate = [...form.querySelectorAll('.form-field')];
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        formFieldsUpdate.forEach(formField => prepare(formField));
      }
    }
  }
  const observer = new MutationObserver(callback);

  const prepare = formField => {
    if (formField.classList.contains('wysiwyg')) {
    }
    else {
      if (formField.querySelector('.form-control') !== null) {
        const input = formField.querySelector('.form-control');

        addEvents(input, 'focus.self', function (e) {
          //if there is a tooltip currently active
          if (form.querySelector('.explanation-text.is-active') !== null) {
            var activeItem = form.querySelector('.explanation-text.is-active')
            activeItem.style.display = 'none';
            activeItem.classList.remove('is-active');
          }
        });
      }
      //if there is a tooltip set it up
      if (formField.querySelector('.explanation-text') !== null && formField.querySelector('.explanation-text') !== undefined) {
        const toolTip = formField.querySelector('.explanation-text');
        const input = formField.querySelector('.form-control');
        toolTip.style.display = 'none';
        if (input !== null) {
          addEvents(input, 'focus.self', function (e) {
            toolTip.style.display = 'block';
            toolTip.classList.add('is-active');
          });
        }
      }
      let sectionHeaders = $("[type='section-header']");

      if (sectionHeaders && sectionHeaders.length > 0) {
        for (var i = 0; i < sectionHeaders.length; i++) {
          var sectionHeader = $(sectionHeaders[i]);
          var localizedPrefix = sectionHeader.attr("prefix");
          sectionHeader.attr("content", localizedPrefix + " " + (i + 1) + ":");
        }
      }
    }
  };
  if (targetNode !== null) {
    observer.observe(targetNode, config);
  }
  formFields.forEach(formField => prepare(formField));
});

ready(
  'currencyFields',
  '.form--stylePrimary',
  form => {
    const formFields = [...form.querySelectorAll('input[data-type=currency]')];
    const config = { attributes: false, childList: true, subtree: true };

    const callback = function (mutationsList, observer) {
      let formFieldsUpdate = [...form.querySelectorAll('input[data-type=currency]')];
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          formFieldsUpdate.forEach(formField => prepare(formField));
        }
      }
    }

    const observer = new MutationObserver(callback);

    const prepare = formField => {
      let includeCommas = formField.parentElement.dataset.currencyCommas;
      let includeDecimals = formField.parentElement.dataset.currencyDecimals;
      let requireNegative = formField.parentElement.dataset.currencyNegative;

      formField.parentElement.dataset.type = "currencyholder";

      addEvents(formField, 'blur', function (e) {
        if (formField.value !== "") {
          let currentDecimalLength = formField.value.split('.')[1] ? formField.value.split('.')[1].length : 0;
          let parsableString = formField.value.replace(/\,/g, '');

          formField.value = includeDecimals && currentDecimalLength > 0
            ? parseFloat(parsableString).toFixed(2)
            : parseInt(parsableString);

          if (requireNegative && formField.value > 0) {
            formField.value = formField.value * -1;
          }

          if (includeCommas) {
            let inputVal = formField.value.toLocaleString("en-US").replace(/^0+/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            formField.value = inputVal;
          }
        }
      });

      addEvents(formField, 'keydown', function (event) {
        var eventKey = event.key;

        if (eventKey.length !== 1) {
          return;
        }

        let decimalIndex = formField.value.indexOf('.');

        if (!(eventKey >= '0' && eventKey <= '9')) {
          if (includeDecimals && eventKey === '.') {
            if (decimalIndex === -1) {
              return;
            }
          }

          if (eventKey === '-') {
            return;
          }

          event.preventDefault();
        }

        let currentDecimalLength = formField.value.split('.')[1] ? formField.value.split('.')[1].length : 0;

        if (decimalIndex === -1) {
          if (formField.value.length >= 12) {
            event.preventDefault();
          }
        } else {
          if (event.target.selectionStart <= decimalIndex) {
            if (formField.value.split('.')[0].length >= 12) {
              event.preventDefault();
            }
          } else {
            if (currentDecimalLength >= 2) {
              event.preventDefault();
            }
          }
        }
      });

      addEvents(formField, 'focus', function (e) {
        if (formField.value !== "") {
          let currentDecimalLength = formField.value.split('.')[1] ? formField.value.split('.')[1].length : 0;
          let parsableString = formField.value.replace(/\,/g, '');

          formField.value = includeDecimals && currentDecimalLength > 0
            ? parseFloat(parsableString).toFixed(2)
            : parseInt(parsableString);
        }
      });
    }

    formFields.forEach(formField => prepare(formField));
    observer.observe(form, config);
  }
);


function setDateFields() {
  var dateFields = document.querySelectorAll('input[type=date]');
  if (dateFields == null || dateFields.length == 0) return;
  var min = '1900-01-01';
  var max = '2100-01-01';
  dateFields.forEach(item => {
    item.setAttribute('min', min);
    item.setAttribute('max', max);
  });
}

function setPhoneFields() {
  var phoneFields = document.querySelectorAll('input[pattern="[0-9]*"]');
  if (phoneFields == null || phoneFields.length == 0) return;

  phoneFields.forEach(item => {
    ["input", "drop",
      "keydown", "keyup",
      "mousedown", "mouseup",
      "select", "contextmenu"].forEach(function (event) {
        item.addEventListener(event, function () {
          if (this.value.length >= 11) {
            this.value = this.oldValue;
          }
          if (validNumber(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          }
          else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          }
          else {
            this.value = "";
          }
        });
      });
  });
}



function validEmail(value) {
  return value.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
}

function validNumber(value) {
  return !isNaN(value);
}


ready('emailField', '.form--stylePrimary', form => {
  // Target only actual email inputs. The old selector `input[id*=Email]` also matched non-email
  // fields whose id contains "Email" (e.g. the "EmailAuth" consent CHECKBOX), whose value "true"
  // failed the email regex and injected a bogus "Please enter email value..." error on that field.
  const formFields = [...form.querySelectorAll('input[type=email]')];
  const config = { attributes: false, childList: true, subtree: true };
  const callback = function (mutationsList, observer) {
    let formFieldsUpdate = [...form.querySelectorAll('input[type=email]')];
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        formFieldsUpdate.forEach(formField => prepare(formField));
      }
    }
  }
  const observer = new MutationObserver(callback);
  const prepare = formField => {
    if (formField == null) return;
    formField.addEventListener('blur', function () {
      if (formField.value != "" && !validEmail(formField.value)) {
        formField.classList.add('input-validation-error');
        formField.nextElementSibling.className = "field-validation-error";
        formField.nextElementSibling.innerHTML = "Please enter email value in format 'mymail@domain.com'.";
      }
      else {
        formField.classList.remove('input-validation-error');
        formField.nextElementSibling.className = "field-validation-valid";
        formField.nextElementSibling.innerHTML = "";
      }
    });
  }
  formFields.forEach(formField => prepare(formField));
  observer.observe(form, config);

});


